module.exports = __webpack_public_path__ + "img/footer.b6c2a30c.png";